import Dialog from "./Dialog";

function StudentCounterModal({ isOpen, request, onClose, onAccept, onReject }) {
  if (!isOpen || !request) return null;

  const fmt = (iso) =>
    new Date(iso).toLocaleString([], {
      weekday: "short", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl"
    >
      {({ titleId }) => (
        <div>
          <h3 id={titleId} className="mb-1 text-lg font-semibold text-gray-900">
            Mentor proposed a new time
          </h3>
          <p className="mb-5 text-sm text-gray-500">
            Review the proposed time and accept or decline.
          </p>

          <div className="mb-4 rounded-xl border border-[#dde0f7] bg-[#eef0fa] px-4 py-3">
            <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-[#282E6A]">Proposed by mentor</p>
            <p className="text-sm font-medium text-[#0f1240]">{request.mentor_name || "Mentor"}</p>
            <p className="mt-0.5 text-sm text-[#282E6A]">
              {fmt(request.requested_start_time)} – {new Date(request.requested_end_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </p>
          </div>

          <div className="mb-4 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
            <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-400">Your original request</p>
            <p className="text-sm text-gray-700">
              {fmt(request.proposed_start_time)} – {new Date(request.proposed_end_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </p>
          </div>

          {request.mentor_message && (
            <div className="mb-5 rounded-xl border border-amber-100 bg-amber-50 px-4 py-3">
              <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-amber-600">Message from mentor</p>
              <p className="text-sm text-gray-700">{request.mentor_message}</p>
            </div>
          )}

          <div className="flex gap-3">
            <button
              onClick={onAccept}
              className="flex-1 rounded-lg bg-[#282E6A] py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1e2458] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#282E6A]"
              data-autofocus="true"
            >
              Accept
            </button>
            <button
              onClick={onReject}
              className="flex-1 rounded-lg bg-red-600 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
            >
              Decline
            </button>
            <button
              onClick={onClose}
              className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#282E6A]"
            >
              Later
            </button>
          </div>
        </div>
      )}
    </Dialog>
  );
}

export default StudentCounterModal;
